import globalAxios from "../GlobalAxios";

const data = async (params) => {
  const res = await globalAxios.get(`/api/dashboard/userdatas`, { params });
  if(res){
    return res.data;
  }
}

const guestData = async (params) => {
  const res = await globalAxios.get(`/api/dashboard/adminuseuserdata`, { params });
  return res.data;
}

const tencent = async () => {
  const res = await globalAxios.get(`/api/dashboard/tencent`);
  return res.data;
}


export default {

  data,
  tencent,
  guestData
};